import { LanguageSelect, Checkbox, Text } from '@msc-b2c/shared-components';
import { RefundPassengerRowProps } from '@msc-b2c/interfaces/types';
import { getAvailablePrice } from '@msc-b2c/shared-utils';
import { getLanguageLabelFromCode } from '../../../utils/myAreaUtils';
import { Price } from './Price';
import styles from './passengers.module.scss';

export function RefundPassengerRow({
  passenger,
  cabinId,
  isChecked,
  disableCabin,
  passengerPriceData,
  onCheckboxChange,
  preferredLangCode,
  excursionLanguageList,
  isExcursionRefund,
  hasSelectedExcursion,
  selectLanguageLabel,
  clearRefundLanguageFieldErrors,
  noopRefundLanguageChange,
}: Readonly<RefundPassengerRowProps>) {
  if (!passenger.id) {
    return null;
  }

  const langCodesForSelect = [...excursionLanguageList];
  if (preferredLangCode && !langCodesForSelect.includes(preferredLangCode)) {
    langCodesForSelect.push(preferredLangCode);
  }
  const languageSelectItems = langCodesForSelect.map((lang) => ({
    value: lang,
    text: getLanguageLabelFromCode(lang),
  }));
  const showBookedLanguageSelect =
    isExcursionRefund &&
    hasSelectedExcursion &&
    !disableCabin &&
    languageSelectItems.length > 0 &&
    (excursionLanguageList.length > 1 || Boolean(preferredLangCode));

  return (
    <div className={styles['passengers__checkboxes__pax']}>
      <div className={styles['passengers__checkboxes__singleBox']}>
        <Checkbox
          checked={isChecked}
          onChange={onCheckboxChange}
          disabled={disableCabin}
          text={
            <>
              <Text text={`${passenger.name} ${passenger.surname}`} />
              {passengerPriceData && getAvailablePrice(passengerPriceData) && (
                <Price
                  passengerPrice={passengerPriceData}
                  isPromotionAvailable={
                    !!passengerPriceData.beforePromotionAndDiscount &&
                    passengerPriceData.beforePromotionAndDiscount !==
                      passengerPriceData.afterDiscount
                  }
                />
              )}
            </>
          }
        />
      </div>
      {showBookedLanguageSelect && (
        <div className={styles['passengers__checkboxes__dropdown']}>
          <LanguageSelect
            passengerId={passenger.id}
            label=""
            placeholder={selectLanguageLabel}
            ariaLabel={selectLanguageLabel}
            items={languageSelectItems}
            fieldName={`refund-excursion.${cabinId}.${passenger.id}.language`}
            value={preferredLangCode}
            onChange={noopRefundLanguageChange}
            onBlur={undefined}
            errors={undefined}
            clearErrors={clearRefundLanguageFieldErrors}
            disabled={true}
          />
        </div>
      )}
    </div>
  );
}
